<template>
  <main class="page-parent">
    <h1 class="page-title">
      {{ $t('tarief.page_title') }}
    </h1>
    <p class="page-subtitle">
      {{ $t('tarief.page_subtitle') }}
    </p>
    <h2 class="content-title">{{ $t('tarief.content_title') }}</h2>
    <p class="content-text">
      {{ $t('tarief.content_text') }}
    </p>
    <Tariff />
    <div class="undo-margin">
      <NetherlandsFormCTA :displayLearnMoreLink="true" />
    </div>
  </main>
</template>

<script>
import NetherlandsFormCTA from '../components/HomePage/NetherlandsFormCTA.vue';
import Tariff from '../components/netherlands/tariffs/Tariff.vue';

export default {
  name: 'NetherlandsTariff',
  components: { NetherlandsFormCTA, Tariff },
};
</script>

<style scoped>
/*
======================
       MOBILE
======================
*/
.page-parent {
  padding-top: 76px;
  min-height: 100vh;
  max-width: 80%;
  margin: 0 auto;
}
.undo-margin {
  margin-left: -13%;
  margin-right: -12.5%;
}

.page-title {
  color: #2b4047;
  font: normal normal bold 45px/50px Foco;
  letter-spacing: 0px;
  margin-top: 40px;
}

.page-subtitle {
  margin-top: 40px;
  font: normal normal normal 16px/22px Lato;
  color: #41565d;
  letter-spacing: 0.16px;
  white-space: pre-line;
}
.content-title {
  margin-top: 90px;
  font: normal normal bold 30px/40px Foco;
  letter-spacing: 0px;
  color: #2b4047;
  position: relative;
  width: max-content;
}
.content-title::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 20px;
  left: 0px;
  top: 60%;
  z-index: -1;
  background: #ffdf22;
}
.content-text {
  margin-top: 23px;
  font: normal normal normal 16px/22px Lato;
  letter-spacing: 0.16px;
  color: #2b4047;
  white-space: pre-line;
}

/*
======================
       DESKTOP
======================
*/

@media (min-width: 1024px) {
  .page-parent {
    margin: 0 auto;
  }
  .page-title {
    font: normal normal bold 70px/80px 'Foco';
    color: #2b4047;
    margin-top: 100px;
  }
  .page-subtitle {
    text-align: left;
    letter-spacing: 0.2px;
    font-family: Lato;
    font-size: 20px;
    margin-top: 50px;
  }
  .content-title {
    font: normal normal bold 40px/55px Lato;
    margin-top: 85px;
    padding: 0 5px;
  }
  .content-title::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 20px;
    left: 0px;
    top: 60%;
    z-index: -1;
    background: #ffdf22;
  }
  .content-text {
    font-size: 20px;
    margin-top: 20px;
    font-family: Lato;
  }
}

/* side margin */
@media (min-width: 768px) {
  .page-parent {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    max-width: 100%;
  }
  .undo-margin {
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }
}
@media (min-width: 1280px) {
  .page-parent {
    padding-left: 140px;
    padding-right: 140px;
  }
  .undo-margin {
    margin-left: -140px;
    margin-right: -140px;
  }
}
@media (min-width: 1680px) {
  .page-parent {
    padding-left: 200px;
    padding-right: 200px;
  }
  .undo-margin {
    margin-left: -200px;
    margin-right: -200px;
  }
}
</style>
